import { IEntity, StandardEntity } from '@infodata-group/inf-commons';
import dayjs from 'dayjs';
import { TitleCasePipe } from '@angular/common';
import isoWeek from 'dayjs/plugin/isoWeek';
import localeFr from 'dayjs/locale/fr';
import { DaySchedule } from './day-schedule';

dayjs.extend(isoWeek);
dayjs.locale(localeFr);
export class Schedule implements IEntity {
  public dayWeek: StandardEntity;
  public dayWeekIndex: number;
  public schedule: DaySchedule[];
  public lock: boolean;

  constructor(dayWeek: number, schedule: { start: string; end: string }[]) {
    this.schedule = schedule.map((s) => new DaySchedule(s.start, s.end));
    this.dayWeekIndex = dayWeek;
    this.generateDayWeek();
  }

  public generateDayWeek() {
    let date = dayjs().startOf('isoWeek');
    date = date.add(this.dayWeekIndex - 1, 'd');
    const dayString = new TitleCasePipe().transform(date.format('dddd'));
    this.dayWeek = new StandardEntity(
      this.dayWeekIndex + '',
      dayString,
      'label',
    );
  }

  toStringArray() {
    return this.schedule.map((s) => `${s.start} - ${s.end}`);
  }

  serialize() {
    return {
      dayWeek: this.dayWeek.id,
      schedule: this.schedule,
    };
  }

  getId(): string {
    return this.dayWeek + '';
  }

  getLabel(): string {
    return this.toStringArray().join(',');
  }

  getTotal() {
    return this.schedule.reduce((total, sch) => (total += sch.getTotal()), 0);
  }
}
